import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Flex, mq } from '@phishtool/ui';
export const StyledWrapper = styled(Flex).withConfig({ displayName: "StyledWrapper", componentId: "-357lr8" }) `
  ${(props) => mq({
    marginTop: [props.theme.spacers.xxl, null, props.theme.spacers.massive],
})}
`;
export const StyledLink = styled(Link).withConfig({ displayName: "StyledLink", componentId: "-1cvz91i" }) `
  display: flex;
  gap: ${(props) => props.theme.spacers.medium};
  color: ${(props) => props.theme.colors.oxfordBlue};
  font-weight: 500;
  text-decoration: none;
  align-items: center;

  ${mq({
    flexDirection: ['column', 'row'],
    fontSize: ['16px', null, '18px'],
})}

  &:hover {
    color: ${(props) => props.theme.colors.celticBlue};
    * {
      fill: ${(props) => props.theme.colors.celticBlue};
    }
  }
`;
